import { render } from "./CommunityTalkMaster.vue?vue&type=template&id=133e339d&ts=true"
import script from "./CommunityTalkMaster.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunityTalkMaster.vue?vue&type=script&lang=ts&setup=true"

import "./CommunityTalkMaster.vue?vue&type=style&index=0&id=133e339d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/CommunityTalkMaster.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "133e339d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('133e339d', __exports__)) {
    api.reload('133e339d', __exports__)
  }
  
  module.hot.accept("./CommunityTalkMaster.vue?vue&type=template&id=133e339d&ts=true", () => {
    api.rerender('133e339d', render)
  })

}


export default __exports__